/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import React, { useState } from "react";
import Button from "./Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import Checkbox from "components/generals/Checkbox";
import { useTranslation } from "react-i18next";
interface ButtonDialogProps {
  onAcceptHandle: (selectedItems?: string[]) => void;
  buttonText: string;
  title: string;
  description: string | { id: string; name: string }[];
  labelledbyID: string;
  describedbyID: string;
  color?: boolean;
  startIcon?: boolean;
  disabled?: boolean;
  name?:string;
}

const ButtonDialog = ({
  onAcceptHandle,
  buttonText,
  title,
  description,
  labelledbyID,
  describedbyID,
  color,
  startIcon,
  disabled,
  name
}: ButtonDialogProps) => {
  const [open, setOpen] = React.useState(false);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const { t } = useTranslation();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCheckboxChange = (item: string) => {
    setSelectedItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleAccept = () => {
    handleClose();
    onAcceptHandle(selectedItems);
  };

  return (
    <>
      <Button
        name={name}
        variant="contained"
        color={color ? "primary" : "error"}
        startIcon={startIcon ? <PrintIcon /> : ""}
        disabled={disabled}
        onClick={handleClickOpen}
      >
        {buttonText}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby={labelledbyID}
        aria-describedby={describedbyID}
      >
        <DialogTitle id={labelledbyID}>{title}</DialogTitle>
        <DialogContent>
          {typeof description === "string" ? (
            <DialogContentText id={describedbyID}>{description}</DialogContentText>
          ) : (
            description.map((item) => (
              <Grid key={item.id}>
                <Checkbox
                  label={item.name}
                  name={item.name}
                  checked={selectedItems.includes(item.id)}
                  onChange={() => handleCheckboxChange(item.id)}
                />
              </Grid>
            ))
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" name="cy-cancel">
            {t("formActionButtons.cancel")}
          </Button>
          <Button onClick={handleAccept} color="primary" autoFocus name="cy-confirm">
            {t("formActionButtons.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ButtonDialog;
